import { createI18n } from 'vue-i18n'

const messages = {
  zh: {
    nav: {
      home: '首页',
      features: '核心特色',
      world: '虚拟世界',
      download: '下载游戏',
      official: '产品官网'
    },
    hero: {
      title: '虚幻与现实',
      subtitle: 'Unreality & Reality · 开放世界 RPG',
      badge: '产品官网',
      desc: '在虚幻与现实的边界，重新定义你的人生。一人探索广袤大世界，或与好友联机组队冒险 —— AI大模型驱动的智能NPC、记忆模型塑造的独特人格，让这个虚拟世界比现实更加真实。',
      tag1: '世界探索',
      tag2: 'AI大模型',
      tag3: '记忆模型',
      tag4: '多人联机'
    },
    features: {
      title: '核心特色',
      subtitle: 'AI与记忆模型驱动的新一代RPG体验',
      ai: {
        title: 'AI大模型驱动',
        desc: '顶尖大模型赋能的NPC系统，每个角色都拥有独立的思维、情感与行为逻辑，告别千篇一律的对话。'
      },
      memory: {
        title: '记忆模型',
        desc: '独创的记忆存储与调用机制，你的经历会被记录、关联和回忆，角色成长轨迹独一无二。'
      },
      world: {
        title: '大世界探索',
        desc: '无缝连接的广袤世界地图，从繁华都市到荒野秘境，每一个角落都有故事等待被发现。'
      },
      multiplayer: {
        title: '多人联网',
        desc: '支持一人独行或数十人同区域联机，组队副本、世界BOSS、公会争霸 —— 玩法无限。'
      },
      roleplay: {
        title: '自由角色扮演',
        desc: '战士、法师、商人、工匠……数百种职业与技能组合，你的人生由你自己定义。'
      },
      weather: {
        title: '实时动态天气',
        desc: '动态天气系统与昼夜循环，影响NPC行为和游戏玩法，让世界真正“活”起来。'
      }
    },
    virtualLife: {
      title: '虚拟人生的\n二次新生',
      desc: '也许现实世界太糟糕，但在这里，你可以从新选择，开始新的人生。',
      memoryModel: {
        title: 'AI记忆模型',
        desc: '你的每一次选择、每一段经历都会被AI记忆模型记录，形成独一无二的角色人格与世界观。'
      },
      evolution: {
        title: '动态世界演化',
        desc: '世界不是静态的 —— NPC的行为、城市的发展、历史的进程，都随玩家集体选择而改变。'
      },
      economy: {
        title: '真实经济系统',
        desc: '区块链技术支撑的虚拟经济体系，你的劳动和创造能在世界中获得真实价值回报。'
      },
      social: {
        title: '无缝社交',
        desc: '一人独行或组队冒险，与来自世界各地的玩家共同书写属于你们的传奇故事。'
      }
    },
    download: {
      title: '立即下载',
      subtitle: '进入虚幻与现实的世界，开启你的第二人生',
      windows: 'Windows 下载',
      mac: 'macOS 下载',
      mobile: '手机版下载',
      soon: '敬请期待',
      qrTip: '扫码下载移动端'
    },
    footer: {
      copyright: '© 2026 虚幻与现实 Unreality & Reality. All rights reserved.',
      slogan: '在虚幻与现实的边界，重新定义你的人生。'
    }
  },
  en: {
    nav: {
      home: 'Home',
      features: 'Features',
      world: 'Virtual World',
      download: 'Download',
      official: 'Official Site'
    },
    hero: {
      title: 'Unreality & Reality',
      subtitle: 'Unreality & Reality · Open World RPG',
      badge: 'Official Site',
      desc: 'At the boundary of unreality and reality, redefine your life. Explore the vast world alone, or team up with friends for adventures — intelligent NPCs powered by large AI models and unique personalities shaped by memory models make this virtual world more real than reality.',
      tag1: 'World Exploration',
      tag2: 'AI Models',
      tag3: 'Memory Models',
      tag4: 'Multiplayer'
    },
    features: {
      title: 'Core Features',
      subtitle: 'A new generation of RPG experience driven by AI and memory models',
      ai: {
        title: 'AI Powered',
        desc: 'Top-tier large language models empower NPCs, giving each character independent thinking, emotions, and behavioral logic — no more repetitive conversations.'
      },
      memory: {
        title: 'Memory Model',
        desc: 'A unique memory storage and retrieval mechanism records, connects, and recalls your experiences, creating a one-of-a-kind character growth path.'
      },
      world: {
        title: 'Open World',
        desc: 'A seamlessly connected vast world map, from bustling cities to wild secret realms — every corner has a story waiting to be discovered.'
      },
      multiplayer: {
        title: 'Multiplayer',
        desc: 'Play solo or with dozens of players in the same region. Team dungeons, world bosses, guild wars — endless possibilities await.'
      },
      roleplay: {
        title: 'Free Roleplay',
        desc: 'Warrior, mage, merchant, craftsman — hundreds of professions and skill combinations let you define your own life.'
      },
      weather: {
        title: 'Dynamic Weather',
        desc: 'Dynamic weather systems and day-night cycles influence NPC behavior and gameplay, making the world truly come alive.'
      }
    },
    virtualLife: {
      title: 'A Second Life\nin the Virtual World',
      desc: 'Maybe the real world is too harsh, but here you can choose anew and start a new life.',
      memoryModel: {
        title: 'AI Memory Model',
        desc: 'Every choice and experience is recorded by the AI memory model, forming a unique character personality and worldview.'
      },
      evolution: {
        title: 'Dynamic World Evolution',
        desc: 'The world is not static — NPC behavior, city development, and historical progress all change with collective player choices.'
      },
      economy: {
        title: 'Real Economy',
        desc: 'A blockchain-backed virtual economy where your labor and creations earn real value in the world.'
      },
      social: {
        title: 'Seamless Social',
        desc: 'Adventure alone or in teams, and write your legendary story together with players from around the world.'
      }
    },
    download: {
      title: 'Download Now',
      subtitle: 'Enter the world of Unreality & Reality and start your second life',
      windows: 'Windows Download',
      mac: 'macOS Download',
      mobile: 'Mobile Download',
      soon: 'Coming Soon',
      qrTip: 'Scan to download mobile version'
    },
    footer: {
      copyright: '© 2026 Unreality & Reality. All rights reserved.',
      slogan: 'At the boundary of unreality and reality, redefine your life.'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'zh',
  fallbackLocale: 'zh',
  messages
})

export default i18n
